module.exports = __webpack_public_path__ + "media/images/desktop/writer-offering-title-b81a8dc4e4da1a04af58c53501965e5b.png";